// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import FormInputs from "../../../Components/Shared/FormInputs/FormInputs";
// import SelectedDropdownValues from "../../../Components/Shared/SelectedValuesDropdown/SelectDropdown";
// import InterogativeImg from "../../../Assets/Images/CommanImages/Informative.png";
// import search from "../../../Assets/Images/CreateRole/Search.png";
// import TableWithCrossStudentGroup from "../../StudentGrouph/TableWithCrossStudentGroup";
// import { API_BASE_URL } from "../../../Config/Config";
// import { useSelector, useDispatch } from "react-redux";
// import { fetchRoleData } from "../../../Redux/features/CreateRole/createRoleSlice";
// import TableWithCrossSelections from "../NewCreateRole/TableWithCrossSelections"; 

// function UpdatedCreateRole({
//   dataClient,
//   setMessageBox,
//   messageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
// }) {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const dropdownRef = useRef(null);
//   const dispatch = useDispatch();

//   // Basic role details
//   const [isOpenShareBranch, setIsOpenShareBranch] = useState(true);
//   const [isOpenReports, setIsOpenReports] = useState(true);
//   const [roleName, setRoleName] = useState("");
//   const [roleCode, setRoleCode] = useState("");
//   const [status, setStatus] = useState(null);
//   const [description, setDescription] = useState("");
//   const [isEditMode, setIsEditMode] = useState(false);

//   // Screen states
//   const [searchText, setSearchText] = useState("");
//   const [selectedScreens, setSelectedScreens] = useState([]);
//   const [searchResults, setSearchResults] = useState([]);
//   const [dropdownVisible, setDropdownVisible] = useState(false);
//   const [permissions, setPermissions] = useState({});
//   const [expandedScreens, setExpandedScreens] = useState({});

//   // Report states
//   const [reportSearchText, setReportSearchText] = useState("");
//   const [reportSearchResults, setReportSearchResults] = useState([]);
//   const [selectedReports, setSelectedReports] = useState([]);
//   const [reportPermissions, setReportPermissions] = useState({});
//   const [reportDropdownVisible, setReportDropdownVisible] = useState(false);

//   const { data, loading, error } = useSelector((state) => state.createRole);
//   const [allScreensData, setAllScreensData] = useState([]); // Store all screens with sections

//   const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name;
//   const clientId = dataClient?.client_schema_name?.[6]?.[0]?.client_id;
//   const clientBranchId = dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id;
//   const accessToken = localStorage.getItem("other");

//   // Extract role_id from URL
//   const queryParams = new URLSearchParams(location.search);
//   const roleId = queryParams.get("MNTCreateRoleID");

//   useEffect(() => {
//     dispatch(fetchRoleData());
//     fetchAllScreensWithSections();
//   }, [dispatch]);

//   // Fetch all screens with sections for mapping
//   const fetchAllScreensWithSections = async () => {
//     try {
//       const response = await fetch(
//         `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-role-screen-access_all/`,
//         {
//           headers: {
//             accept: "application/json",
//           },
//         }
//       );
//       const result = await response.json();
//       if (result) {
//         setAllScreensData(result);
//       }
//     } catch (error) {
//       console.error("Error fetching all screens data:", error);
//     }
//   };

//   // Fetch role details, screens, and reports
//   useEffect(() => {
//     if (roleId && allScreensData.length > 0) {
//       fetchRoleDetails();
//       fetchScreensByRoleId();
//       fetchReportsByRoleId();
//     }
//   }, [roleId, allScreensData]);

//   const fetchRoleDetails = async () => {
//     try {
//       const response = await fetch(
//         `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-role-details-by-id/?role_id=${roleId}`,
//         {
//           headers: {
//             accept: "application/json",
//             Authorization: `Bearer ${accessToken}`,
//           },
//         }
//       );
//       const result = await response.json();
//       if (result) {
//         setRoleName(result.role_name || "");
//         setRoleCode(result.role_code || "");
//         setDescription(result.role_desc || "");
//         setStatus(result.status);
//       }
//     } catch (error) {
//       console.error("Error fetching role details:", error);
//     }
//   };

//   const fetchScreensByRoleId = async () => {
//     try {
//       const response = await fetch(
//         `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-screen-list-by-role-id?role_id=${roleId}`,
//         {
//           headers: {
//             accept: "application/json",
//             Authorization: `Bearer ${accessToken}`,
//           },
//         }
//       );
//       const result = await response.json();
      
//       if (result.status === 200 && result.data) {
//         // Group by screen_id
//         const screenMap = {};
//         result.data.forEach((item) => {
//           if (!screenMap[item.screen_id]) {
//             // Find screen from allScreensData to get complete section info
//             const screenInfo = allScreensData.find(s => s.screen_id === item.screen_id);
            
//             screenMap[item.screen_id] = {
//               screen_id: item.screen_id,
//               screen_name: item.screen_name,
//               sections: screenInfo?.sections || [],
//             };
//           }
//         });

//         const screens = Object.values(screenMap);
//         setSelectedScreens(screens);

//         // Set permissions from API data
//         const permsObj = {};
//         result.data.forEach((item) => {
//           if (!permsObj[item.screen_id]) {
//             permsObj[item.screen_id] = {
//               create: item.create_perm === 1,
//               read: item.read_perm === 1,
//               delete: item.delete_perm === 1,
//               print: item.print === 1,
//               download: item.download === 1,
//               sections: {},
//             };
//           }

//           if (item.wb_scr_sec_id) {
//             permsObj[item.screen_id].sections[item.wb_scr_sec_id] = {
//               edit: item.update_perm === 1,
//             };
//           } else {
//             permsObj[item.screen_id].edit = item.update_perm === 1;
//           }
//         });

//         // Check if all sections are selected
//         Object.keys(permsObj).forEach((screenId) => {
//           const screen = screens.find((s) => s.screen_id === parseInt(screenId));
//           if (screen && screen.sections.length > 0) {
//             const allChecked = screen.sections.every(
//               (sec) => permsObj[screenId].sections[sec.sec_id]?.edit
//             );
//             permsObj[screenId].allSections = allChecked;
//           }
//         });

//         setPermissions(permsObj);
//       }
//     } catch (error) {
//       console.error("Error fetching screens:", error);
//     }
//   };

//   const fetchReportsByRoleId = async () => {
//     try {
//       const response = await fetch(
//         `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-report-list-by-role-id?role_id=${roleId}`,
//         {
//           headers: {
//             accept: "application/json",
//             Authorization: `Bearer ${accessToken}`,
//           },
//         }
//       );
//       const result = await response.json();
      
//       if (result.status === 200 && result.data) {
//         const reports = result.data.map((item) => ({
//           report_id: item.report_id,
//           display_name: item.report_name,
//         }));
//         setSelectedReports(reports);

//         // Set report permissions
//         const reportPermsObj = {};
//         result.data.forEach((item) => {
//           reportPermsObj[item.report_id] = {
//             print: item.print === 1,
//             download: item.download === 1,
//           };
//         });
//         setReportPermissions(reportPermsObj);
//       }
//     } catch (error) {
//       console.error("Error fetching reports:", error);
//     }
//   };

//   // Close dropdown on outside click
//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setDropdownVisible(false);
//         setReportDropdownVisible(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const handleSearch = () => {
//     if (searchText.trim().length > 0) {
//       const filtered = data.filter((item) =>
//         item.screen_name.toLowerCase().includes(searchText.toLowerCase())
//       );
//       setSearchResults(filtered);
//       setDropdownVisible(filtered.length > 0);
//     } else {
//       setDropdownVisible(false);
//       setSearchResults([]);
//     }
//   };

//   const handleSelectItem = (item) => {
//     if (!selectedScreens.some((screen) => screen.screen_id === item.screen_id)) {
//       setSelectedScreens([...selectedScreens, item]);
//     }
//     setDropdownVisible(false);
//     setSearchText("");
//   };

//   const toggleExpand = (screenId) => {
//     setExpandedScreens((prev) => ({
//       ...prev,
//       [screenId]: !prev[screenId],
//     }));
//   };

//   const handleReportSearch = async () => {
//     if (reportSearchText.trim().length > 0) {
//       try {
//         const response = await fetch(
//           `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-report-list-by-search-key?search_key=${reportSearchText}`,
//           {
//             method: "GET",
//             headers: {
//               accept: "application/json",
//               Authorization: `Bearer ${accessToken}`,
//             },
//           }
//         );
//         const result = await response.json();
//         if (result.status === 200 && result.data) {
//           setReportSearchResults(result.data);
//           setReportDropdownVisible(result.data.length > 0);
//         }
//       } catch (error) {
//         console.error("Error fetching reports:", error);
//       }
//     } else {
//       setReportDropdownVisible(false);
//       setReportSearchResults([]);
//     }
//   };

//   const handleSelectReport = (report) => {
//     if (!selectedReports.some((r) => r.report_id === report.report_id)) {
//       setSelectedReports([...selectedReports, report]);
//     }
//     setReportDropdownVisible(false);
//     setReportSearchText("");
//   };

//   const handleDeleteReport = (reportId) => {
//     setSelectedReports(selectedReports.filter((r) => r.report_id !== reportId));
//     const updated = { ...reportPermissions };
//     delete updated[reportId];
//     setReportPermissions(updated);
//   };

//   const handleReportPermissionChange = (reportId, type, checked) => {
//     setReportPermissions((prev) => ({
//       ...prev,
//       [reportId]: {
//         ...prev[reportId],
//         [type]: checked,
//       },
//     }));
//   };

//   // const handleUpdate = async () => {
//   //   if (!roleName || !roleCode || !description) {
//   //     setIsMessageBoxVisible(true);
//   //     setMessageBox(
//   //       <div className="Container-messageBOX">
//   //         <div className="messagebox-insider1">
//   //           <div className="loader-tc"></div>
//   //           <span>Please fill all required fields!</span>
//   //         </div>
//   //       </div>
//   //     );
//   //     setActiveImg(InterogativeImg);
//   //     return;
//   //   }

//   //   const role_screen_list = selectedScreens.flatMap((screen) => {
//   //     const perms = permissions[screen.screen_id] || {};

//   //     if (screen.sections && screen.sections.length > 0) {
//   //       return screen.sections.map((section) => ({
//   //         role_id: parseInt(roleId),
//   //         screen_id: screen.screen_id,
//   //         wb_scr_sec_id: section.sec_id,
//   //         client_id: clientId,
//   //         create_perm: perms.create ? 1 : 0,
//   //         read_perm: perms.read ? 1 : 0,
//   //         update_perm: perms.sections?.[section.sec_id]?.edit || perms.edit ? 1 : 0,
//   //         delete_perm: perms.delete ? 1 : 0,
//   //         create_date: new Date().toISOString(),
//   //         created_by: userName,
//   //         last_modified_by: userName,
//   //         last_modified_date: new Date().toISOString(),
//   //         print: perms.print ? 1 : 0,
//   //         download: perms.download ? 1 : 0,
//   //       }));
//   //     }

//   //     return {
//   //       role_id: parseInt(roleId),
//   //       screen_id: screen.screen_id,
//   //       wb_scr_sec_id: null,
//   //       client_id: clientId,
//   //       create_perm: perms.create ? 1 : 0,
//   //       read_perm: perms.read ? 1 : 0,
//   //       update_perm: perms.edit ? 1 : 0,
//   //       delete_perm: perms.delete ? 1 : 0,
//   //       create_date: new Date().toISOString(),
//   //       created_by: userName,
//   //       last_modified_by: userName,
//   //       last_modified_date: new Date().toISOString(),
//   //       print: perms.print ? 1 : 0,
//   //       download: perms.download ? 1 : 0,
//   //     };
//   //   });

//   //   const role_report_list = selectedReports.map((report) => {
//   //     const perms = reportPermissions[report.report_id] || {};
//   //     return {
//   //       role_id: parseInt(roleId),
//   //       report_id: report.report_id,
//   //       client_id: clientId,
//   //       create_date: new Date().toISOString(),
//   //       created_by: userName,
//   //       last_modified_by: userName,
//   //       last_modified_date: new Date().toISOString(),
//   //       print: perms.print ? 1 : 0,
//   //       download: perms.download ? 1 : 0,
//   //     };
//   //   });

//   //   try {
//   //     const url = `${API_BASE_URL}/coaching-collaborator-api/api/v1/update-role-details?role_id=${roleId}&role_code=${roleCode}&role_name=${roleName}&role_desc=${description}&user_name=${userName}&status=${status}`;

//   //     const response = await fetch(url, {
//   //       method: "PUT",
//   //       headers: {
//   //         accept: "application/json",
//   //         Authorization: `Bearer ${accessToken}`,
//   //         "Content-Type": "application/json",
//   //       },
//   //       body: JSON.stringify({
//   //         role_screen_list,
//   //         role_report_list,
//   //       }),
//   //     });

//   //     const result = await response.json();

//   //     if (response.ok) {
//   //       setIsMessageBoxVisible(true);
//   //       setMessageBox(
//   //         <div className="Container-messageBOX">
//   //           <div className="messagebox-insider1">
//   //             <div className="loader-tc"></div>
//   //             <span>{result.message || "Role updated successfully!"}</span>
//   //           </div>
//   //         </div>
//   //       );
//   //       setActiveImg(InterogativeImg);
//   //       setIsEditMode(false);
//   //       setTimeout(() => navigate("/create_role_dashboard"), 1000);
//   //     } else {
//   //       throw new Error(result.message || "Failed to update role");
//   //     }
//   //   } catch (error) {
//   //     console.error("Error updating role:", error);
//   //     setIsMessageBoxVisible(true);
//   //     setMessageBox(
//   //       <div className="Container-messageBOX">
//   //         <div className="messagebox-insider1">
//   //           <div className="loader-tc"></div>
//   //           <span>{`Error: ${error.message}`}</span>
//   //         </div>
//   //       </div>
//   //     );
//   //     setActiveImg(InterogativeImg);
//   //   }
//   // };


//   const handleUpdate = async (newStatus = status) => {
//     if (!roleName || !roleCode || !description) {
//       setIsMessageBoxVisible(true);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>Please fill all required fields!</span>
//           </div>
//         </div>
//       );
//       setActiveImg(InterogativeImg);
//       return;
//     }

//     const role_screen_list = selectedScreens.flatMap((screen) => {
//       const perms = permissions[screen.screen_id] || {};

//       if (screen.sections?.length > 0) {
//         return screen.sections.map((section) => ({
//           role_id: parseInt(roleId),
//           screen_id: screen.screen_id,
//           wb_scr_sec_id: section.sec_id,
//           client_id: clientId,
//           create_perm: perms.create ? 1 : 0,
//           read_perm: perms.read ? 1 : 0,
//           update_perm: perms.sections?.[section.sec_id]?.edit || perms.edit ? 1 : 0,
//           delete_perm: perms.delete ? 1 : 0,
//           create_date: new Date().toISOString(),
//           created_by: userName,
//           last_modified_by: userName,
//           last_modified_date: new Date().toISOString(),
//           print: perms.print ? 1 : 0,
//           download: perms.download ? 1 : 0,
//         }));
//       }

//       return {
//         role_id: parseInt(roleId),
//         screen_id: screen.screen_id,
//         wb_scr_sec_id: null,
//         client_id: clientId,
//         create_perm: perms.create ? 1 : 0,
//         read_perm: perms.read ? 1 : 0,
//         update_perm: perms.edit ? 1 : 0,
//         delete_perm: perms.delete ? 1 : 0,
//         create_date: new Date().toISOString(),
//         created_by: userName,
//         last_modified_by: userName,
//         last_modified_date: new Date().toISOString(),
//         print: perms.print ? 1 : 0,
//         download: perms.download ? 1 : 0,
//       };
//     });

//     const role_report_list = selectedReports.map((report) => {
//       const perms = reportPermissions[report.report_id] || {};
//       return {
//         role_id: parseInt(roleId),
//         report_id: report.report_id,
//         client_id: clientId,
//         create_date: new Date().toISOString(),
//         created_by: userName,
//         last_modified_by: userName,
//         last_modified_date: new Date().toISOString(),
//         print: perms.print ? 1 : 0,
//         download: perms.download ? 1 : 0,
//       };
//     });

//     try {
//       const url = `${API_BASE_URL}/coaching-collaborator-api/api/v1/update-role-details?role_id=${roleId}&role_code=${roleCode}&role_name=${roleName}&role_desc=${description}&user_name=${userName}&status=${newStatus}`;

//       const response = await fetch(url, {
//         method: "PUT",
//         headers: {
//           accept: "application/json",
//           Authorization: `Bearer ${accessToken}`,
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           role_screen_list,
//           role_report_list,
//         }),
//       });

//       const result = await response.json();

//       if (response.ok) {
//         setIsMessageBoxVisible(true);
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>{result.message || "Role updated successfully!"}</span>
//             </div>
//           </div>
//         );
//         setActiveImg(InterogativeImg);
//         setIsEditMode(false);
//         setTimeout(() => navigate("/create_role_dashboard"), 1000);
//       } else {
//         throw new Error(result.message || "Failed to update role");
//       }
//     } catch (error) {
//       console.error("Error updating role:", error);
//       setIsMessageBoxVisible(true);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>{`Error: ${error.message}`}</span>
//           </div>
//         </div>
//       );
//       setActiveImg(InterogativeImg);
//     }
//   };

//   const headers = [
//       "Screen Name",
//       "Edit",
//       "Create",
//       "Read",
//       "Delete",
//       "Print",
//       "Download",
//     ];

//     // 2. Updated tableData to fix expansion and auto-check/uncheck logic
//     const tableData = selectedScreens.map((screen) => {
//       const perms = permissions[screen.screen_id] || {};
//       const isExpanded = expandedScreens[screen.screen_id];
//       const sectionList = screen.sections || [];
//       const hasSections = sectionList.length > 0;

//       return [
//         // 1️⃣ Screen Name
//         screen.screen_name,

//         // 2️⃣ Edit Column with All Sections checkbox and expandable sections
//         <div style={{ display: "flex", flexDirection: "column" }}>
//           <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
//             {/* All Sections Checkbox - only show if screen has sections */}
//             {hasSections && (
//               <>
//                 <input
//                   type="checkbox"
//                   className="cr-custom-checkbox"
//                   checked={perms.allSections || false}
//                   onChange={(e) => {
//                     const checked = e.target.checked;
//                     handlePermissionChange(screen.screen_id, null, "allSections", checked);
                    
//                     // Don't auto-expand/collapse when checking/unchecking
//                     // Let user control expansion manually with +/- icon
//                   }}
//                   disabled={!isEditMode}
//                 />

//                 {/* Expand/Collapse Icon - always clickable */}
//                 <span
//                   onClick={() => toggleExpand(screen.screen_id)}
//                   style={{
//                     cursor: "pointer",
//                     fontWeight: "bold",
//                     marginLeft: "8px",
//                     userSelect: "none",
//                   }}
//                 >
//                   {isExpanded ? "−" : "+"}
//                 </span>

//                 <span style={{ marginLeft: "8px", marginRight: "20px" }}>
//                   All Sections
//                 </span>
//               </>
//             )}
            
//             {/* If no sections, show single checkbox for edit permission */}
//             {!hasSections && (
//               <input
//                 type="checkbox"
//                 className="cr-custom-checkbox"
//                 checked={perms.edit || false}
//                 onChange={(e) =>
//                   handlePermissionChange(screen.screen_id, null, "edit", e.target.checked)
//                 }
//               />
//             )}
//           </div>

//           {/* Expandable sections list */}
//           {hasSections && isExpanded && (
//             <div
//               style={{
//                 marginTop: "10px",
//                 display: "flex",
//                 marginLeft: "24px",
//                 flexDirection: "column",
//                 gap: "10px",
//               }}
//             >
//               {sectionList.map((section) => {
//                 const secPerm = perms.sections?.[section.sec_id]?.edit || false;
//                 return (
//                   <label key={section.sec_id} style={{ display: "flex", gap: "6px" }}>
//                     <input
//                       type="checkbox"
//                       className="cr-custom-checkbox"
//                       checked={secPerm}
//                       onChange={(e) => {
//                         handlePermissionChange(
//                           screen.screen_id,
//                           section.sec_id,
//                           "edit",
//                           e.target.checked
//                         );
//                       }}
//                       disabled={!isEditMode}
//                     />
//                     {section.sec_name}
//                   </label>
//                 );
//               })}
//             </div>
//           )}
//         </div>,

//         // 3️⃣ Create
//         <input
//           type="checkbox"
//           className="cr-custom-checkbox"
//           checked={perms.create || false}
//           onChange={(e) =>
//             handlePermissionChange(screen.screen_id, null, "create", e.target.checked)
//           }
//           disabled={!isEditMode}
//         />,

//         // 4️⃣ Read
//         <input
//           type="checkbox"
//           className="cr-custom-checkbox"
//           checked={perms.read || false}
//           onChange={(e) =>
//             handlePermissionChange(screen.screen_id, null, "read", e.target.checked)
//           }
//           disabled={!isEditMode}
//         />,

//         // 5️⃣ Delete
//         <input
//           type="checkbox"
//           className="cr-custom-checkbox"
//           checked={perms.delete || false}
//           onChange={(e) =>
//             handlePermissionChange(screen.screen_id, null, "delete", e.target.checked)
//           }
//           disabled={!isEditMode}
//         />,

//         // 6️⃣ Print
//         <input
//           type="checkbox"
//           className="cr-custom-checkbox"
//           checked={perms.print || false}
//           onChange={(e) =>
//             handlePermissionChange(screen.screen_id, null, "print", e.target.checked)
//           }
//           disabled={!isEditMode}
//         />,

//         // 7️⃣ Download
//         <input
//           type="checkbox"
//           className="cr-custom-checkbox"
//           checked={perms.download || false}
//           onChange={(e) =>
//             handlePermissionChange(screen.screen_id, null, "download", e.target.checked)
//           }
//           disabled={!isEditMode}
//         />,
//       ];
//     });

//     // 3. Updated handlePermissionChange to properly handle auto-check/uncheck
//     const handlePermissionChange = (screenId, secId, permissionType, checked) => {
//       setPermissions((prev) => {
//         const currentScreenPerms = prev[screenId] || {};
//         const currentSections = currentScreenPerms.sections || {};
//         const updatedSections = { ...currentSections };
//         const screen = selectedScreens.find(s => s.screen_id === screenId);
//         const sectionList = screen?.sections || [];

//         // Handle "All Sections" checkbox
//         if (permissionType === "allSections") {
//           const newSections = {};
//           sectionList.forEach(sec => {
//             newSections[sec.sec_id] = {
//               ...(updatedSections[sec.sec_id] || {}),
//               edit: checked,
//             };
//           });

//           return {
//             ...prev,
//             [screenId]: {
//               ...currentScreenPerms,
//               allSections: checked,
//               edit: checked,
//               sections: newSections,
//             },
//           };
//         }

//         if (secId) {
//           updatedSections[secId] = {
//             ...(updatedSections[secId] || {}),
//             edit: checked,
//           };

//           // Check if ALL sections are now checked (for auto-checking "All Sections")
//           const allChecked = sectionList.every(sec => updatedSections[sec.sec_id]?.edit);
          
//           // Check if ALL sections are now UNCHECKED (for auto-unchecking "All Sections")
//           const allUnchecked = sectionList.every(sec => !updatedSections[sec.sec_id]?.edit);
          
//           // Check if any section is checked (for edit permission)
//           const anyChecked = sectionList.some(sec => updatedSections[sec.sec_id]?.edit);

//           return {
//             ...prev,
//             [screenId]: {
//               ...currentScreenPerms,
//               // Only update "All Sections" if ALL are checked OR ALL are unchecked
//               allSections: allChecked ? true : (allUnchecked ? false : currentScreenPerms.allSections),
//               edit: anyChecked,
//               sections: updatedSections,
//             },
//           };
//         }

//         // Handle other permissions (create, read, delete, print, download)
//         const updatedScreenPerms = {
//           ...currentScreenPerms,
//           [permissionType]: checked,
//           sections: updatedSections,
//         };

//         // Auto-check download when print is checked
//         if (permissionType === "print" && checked) {
//           updatedScreenPerms.download = true;
//         }

//         return {
//           ...prev,
//           [screenId]: updatedScreenPerms,
//         };
//       });
//     };

//     // 4. Updated handleDeleteItem to also pass screen_id instead of screenId
//     const handleDeleteItem = (screenName) => {
//       // Find the screen by name to get its ID
//       const screenToDelete = selectedScreens.find(s => s.screen_name === screenName);
//       if (!screenToDelete) return;
      
//       setSelectedScreens(selectedScreens.filter((s) => s.screen_id !== screenToDelete.screen_id));
//       const updatedPermissions = { ...permissions };
//       delete updatedPermissions[screenToDelete.screen_id];
//       setPermissions(updatedPermissions);
//     };


//   const reportHeaders = ["Report Name", "Print", "Download"];

//   const reportTableData = selectedReports.map((report) => {
//     const perms = reportPermissions[report.report_id] || {};

//     return [
//       report.display_name,
//       <input
//         type="checkbox"
//         className="cr-custom-checkbox"
//         checked={perms.print || false}
//         disabled={!isEditMode}
//         onChange={(e) =>
//           handleReportPermissionChange(report.report_id, "print", e.target.checked)
//         }
//       />,
//       <input
//         type="checkbox"
//         className="cr-custom-checkbox"
//         checked={perms.download || false}
//         disabled={!isEditMode}
//         onChange={(e) =>
//           handleReportPermissionChange(report.report_id, "download", e.target.checked)
//         }
//       />,
//     ];
//   });


//   const updateRoleStatus = (newStatus) => {
//     setStatus(newStatus);   
//     handleUpdate(newStatus); 
//   };


//   return (
//     <div className="create-role-container">
//       <div className="create-role-container-ques-paper-del">
//         <span className="create-role-heading">Update Role</span>
//         <div className="cr-header-btn-container">
//           <button
//             className="cr-cancel-btn"
//             onClick={() => navigate("/create_role_dashboard")}
//           >
//             CANCEL
//           </button>
//           {status === 1 && (
//             <button
//               className="cr-cancel-btn"
//               style={{ width: "140px" }}
//               onClick={() => updateRoleStatus(0)}
//             >
//               DEACTIVATE
//             </button>
//           )}
//           {status === 0 && (
//             <button
//               className="cr-create-btn"
//               style={{ width: "140px" }}
//               onClick={() => updateRoleStatus(1)}
//             >
//               ACTIVATE
//             </button>
//           )}
//           {!isEditMode ? (
//             <button className="cr-create-btn" onClick={() => setIsEditMode(true)}>
//               EDIT
//             </button>
//           ) : (
//             <button className="cr-create-btn" onClick={() => handleUpdate(status)}>
//               SAVE
//             </button>
//           )}
//         </div>
//       </div>

//       {/* Details Section */}
//       <div className="ques-paper-del">
//         <div className="personal-header">
//           <div className="header">
//             <label>Details</label>
//           </div>
//         </div>

//         <div className="accordion-content">
//           <div className="select-assign-test-container-ques-pap-del">
//             <div className="grid-container-ques-paper-del">
//               <div className="item1">
//                 <FormInputs
//                   label="Role Name"
//                   type="text"
//                   required
//                   value={roleName}
//                   onChange={(e) => setRoleName(e.target.value)}
//                   disabled={!isEditMode}
//                 />
//               </div>

//               <div className="item2">
//                 <FormInputs
//                   label="Role Code"
//                   type="text"
//                   required
//                   value={roleCode}
//                   onChange={(e) => setRoleCode(e.target.value)}
//                   disabled={!isEditMode}
//                 />
//               </div>

//               <div className="item3">
//                 <SelectedDropdownValues
//                   label="Status"
//                   options={[
//                     { id: 1, label: "Active" },
//                     { id: 2, label: "Inactive" },
//                   ]}
//                   selected={status}
//                   setSelected={setStatus}
//                   isRequired={true}
//                   required
//                   disabled={true}
//                 />
//               </div>

//               <div className="item4-creaete-role-description">
//                 <FormInputs
//                   label="Description"
//                   type="textarea"
//                   value={description}
//                   onChange={(e) => setDescription(e.target.value)}
//                   required
//                   disabled={!isEditMode}
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Add Screens Section */}
//       <div className="ques-paper-del" style={{ marginTop: "20px" }}>
//         <div className="personal-header">
//           <div className="header">
//             <label>ADD SCREENS</label>
//           </div>
//           <div
//             className="accordion-btn"
//             onClick={() => setIsOpenShareBranch((prev) => !prev)}
//           >
//             {isOpenShareBranch ? <div className="minus"></div> : <div className="plus">+</div>}
//           </div>
//         </div>

//         {isOpenShareBranch && (
//           <div className="accordion-content" style={{ padding: "20px 0px 20px 0px" }}>
//             {isEditMode && (
//               <div className="grid-container-ques-paper-del">
//                 <div className="cr-screens-container">
//                   <div className="cr-screen-search-container">
//                     <input
//                       type="text"
//                       placeholder="Type here to search"
//                       value={searchText}
//                       onChange={(e) => setSearchText(e.target.value)}
//                       className="cr-add-screen-input"
//                       onFocus={() => handleSearch()}
//                     />
//                     <button className="cr-add-screen-button" onClick={handleSearch}>
//                       <img
//                         src={search}
//                         alt="search icon"
//                         style={{ width: "30px", height: "31px" }}
//                       />
//                     </button>
//                   </div>

//                   {dropdownVisible && (
//                     <ul
//                       className="cr-screen-dropdown"
//                       ref={dropdownRef}
//                       style={{
//                         width: "100%",
//                         overflowY: "auto",
//                         marginLeft: "20px",
//                         color: "#6A6A6A",
//                       }}
//                     >
//                       {searchResults.map((item) => (
//                         <li key={item.screen_id} onClick={() => handleSelectItem(item)}>
//                           {item.screen_name}
//                         </li>
//                       ))}
//                     </ul>
//                   )}
//                 </div>
//               </div>
//             )}
//             {selectedScreens.length > 0 && (
//               <div>
//                 <TableWithCrossSelections
//                   headers={headers}
//                   data={tableData}
//                   searchPlaceholder="Search screens..."
//                   selectedRows={[]}
//                   setSelectedRows={() => {}}
//                   renderQuestionText={(text) => text}
//                   renderQuestionTextModel={(text) => text}
//                   expandedStates={{}}
//                   toggleImage={() => {}}
//                   pageType="userEdit"
//                   onRowLinkClick={(row) => console.log("Row clicked:", row)}
//                   filterConfig={{}}
//                   handleDeleteRow={
//                     isEditMode
//                       ? (rowIndex) => {
//                           const screen = selectedScreens[rowIndex];
//                           handleDeleteItem(screen.screen_id);
//                         }
//                       : null
//                   }
//                 />
//               </div>
//             )}
//           </div>
//         )}
//       </div>

//       {/* Add Reports Section */}
//       <div className="ques-paper-del" style={{ marginTop: "20px" }}>
//         <div className="personal-header">
//           <div className="header">
//             <label>ADD REPORTS NAME</label>
//           </div>
//           <div className="accordion-btn" onClick={() => setIsOpenReports((p) => !p)}>
//             {isOpenReports ? <div className="minus"></div> : <div className="plus">+</div>}
//           </div>
//         </div>

//         {isOpenReports && (
//           <div className="accordion-content" style={{ padding: "20px 0px" }}>
//             {isEditMode && (
//               <div className="grid-container-ques-paper-del">
//                 <div className="cr-screens-container">
//                   <div className="cr-screen-search-container">
//                     <input
//                       type="text"
//                       placeholder="Search Report"
//                       value={reportSearchText}
//                       onChange={(e) => setReportSearchText(e.target.value)}
//                       className="cr-add-screen-input"
//                       onFocus={() => handleReportSearch()}
//                     />
//                     <button className="cr-add-screen-button" onClick={handleReportSearch}>
//                       <img
//                         src={search}
//                         alt="search icon"
//                         style={{ width: "30px", height: "31px" }}
//                       />
//                     </button>
//                   </div>

//                   {reportDropdownVisible && (
//                     <ul
//                       className="cr-screen-dropdown"
//                       ref={dropdownRef}
//                       style={{
//                         width: "100%",
//                         overflowY: "auto",
//                         marginLeft: "20px",
//                         color: "#6A6A6A",
//                       }}
//                     >
//                       {reportSearchResults.map((item) => (
//                         <li key={item.report_id} onClick={() => handleSelectReport(item)}>
//                           {item.display_name}
//                         </li>
//                       ))}
//                     </ul>
//                   )}
//                 </div>
//               </div>
//             )}

//             {selectedReports.length > 0 && (
//               <div style={{ marginTop: "20px" }}>
//                 <TableWithCrossStudentGroup
//                   headers={reportHeaders}
//                   data={reportTableData}
//                   searchPlaceholder="Search reports..."
//                   selectedRows={[]}
//                   setSelectedRows={() => {}}
//                   renderQuestionText={(text) => text}
//                   renderQuestionTextModel={(text) => text}
//                   expandedStates={{}}
//                   toggleImage={() => {}}
//                   pageType="userEdit"
//                   onRowLinkClick={(row) => console.log("Report clicked:", row)}
//                   filterConfig={{}}
//                   handleDeleteRow={
//                     isEditMode
//                       ? (rowIndex) => {
//                           const report = selectedReports[rowIndex];
//                           handleDeleteReport(report.report_id);
//                         }
//                       : null
//                   }
//                 />
//               </div>
//             )}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default UpdatedCreateRole;





import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import FormInputs from "../../../Components/Shared/FormInputs/FormInputs";
import SelectedDropdownValues from "../../../Components/Shared/SelectedValuesDropdown/SelectDropdown";
import InterogativeImg from "../../../Assets/Images/CommanImages/Informative.png";
import TableWithCrossStudentGroup from "../../StudentGrouph/TableWithCrossStudentGroup";
import TableWithCrossSelections from "../NewCreateRole/TableWithCrossSelections"; 
import DropdownWithPagination from "../../StudentGrouph/DropdownWithPagination";
import { API_BASE_URL } from "../../../Config/Config";
import { useSelector, useDispatch } from "react-redux";
import { fetchRoleData } from "../../../Redux/features/CreateRole/createRoleSlice";
import ErrorIcon from "../../../Assets/Images/CommanImages/Error.png";
import Endpoints from "../../../Api/Endpoints";

function UpdatedCreateRole({
  dataClient,
  setMessageBox,
  messageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  setNoTimeSet,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const isUpdatingFromScreenTable = useRef(false);
  const isUpdatingFromReportTable = useRef(false);

  // Basic role details
  const [isOpenShareBranch, setIsOpenShareBranch] = useState(true);
  const [isOpenReports, setIsOpenReports] = useState(true);
  const [roleName, setRoleName] = useState("");
  const [roleCode, setRoleCode] = useState("");
  const [status, setStatus] = useState(null);
  const [description, setDescription] = useState("");
  const [isEditMode, setIsEditMode] = useState(false);

  // Screen states
  const [selectedScreens, setSelectedScreens] = useState([]);
  const [screenOptions, setScreenOptions] = useState([]);
  const [permissions, setPermissions] = useState({});
  const [expandedScreens, setExpandedScreens] = useState({});

  // Report states
  const [selectedReports, setSelectedReports] = useState([]);
  const [reportOptions, setReportOptions] = useState([]);
  const [reportPermissions, setReportPermissions] = useState({});

  const { data, loading, error } = useSelector((state) => state.createRole);
  const [allScreensData, setAllScreensData] = useState([]);

  const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name;
  const clientId = dataClient?.client_schema_name?.[6]?.[0]?.client_id;
  const clientBranchId = dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id;
  const accessToken = localStorage.getItem("other");

  // Extract role_id from URL
  const queryParams = new URLSearchParams(location.search);
  const roleId = queryParams.get("MNTCreateRoleID");

  useEffect(() => {
    dispatch(fetchRoleData());
    fetchAllScreensWithSections();
  }, [dispatch]);

  // Fetch all screens with sections for mapping
  const fetchAllScreensWithSections = async () => {
    try {
      const response = await fetch(
        `${Endpoints.PRISM_GET_ROLE_SCREEN_ACCESS_ALL}`,
        {
          headers: {
            accept: "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      const result = await response.json();
      if (result) {
        setAllScreensData(result);
      }
    } catch (error) {
      console.error("Error fetching all screens data:", error);
    }
  };

  // Fetch role details, screens, and reports
  useEffect(() => {
    if (roleId && allScreensData.length > 0) {
      fetchRoleDetails();
      fetchScreensByRoleId();
      fetchReportsByRoleId();
    }
  }, [roleId, allScreensData]);


  // Add this useEffect to automatically set Read permission when screens are selected
useEffect(() => {
  if (selectedScreens.length > 0) {
    setPermissions((prev) => {
      const updated = { ...prev };
      selectedScreens.forEach((screenId) => {
        if (!updated[screenId]) {
          updated[screenId] = {
            create: false,
            read: true, // Always set Read to true for new screens
            edit: false,
            delete: false,
            print: false,
            sections: {},
          };
        } else if (!updated[screenId].read) {
          // Ensure Read is always true even if it was previously false
          updated[screenId].read = true;
        }
      });
      return updated;
    });
  }
}, [selectedScreens]);

  const fetchRoleDetails = async () => {
    try {
      const response = await fetch(
        `${Endpoints.PRISM_GET_ROLE_DETAILS_BY_ID}?role_id=${roleId}`,
        {
          headers: {
            accept: "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      const result1 = await response.json();
      const result = result1?.data;
      if (result) {
        setRoleName(result.role_name || "");
        setRoleCode(result.role_code || "");
        setDescription(result.role_desc || "");
        setStatus(result.status);
      }
    } catch (error) {
      console.error("Error fetching role details:", error);
    }
  };

  const fetchScreensByRoleId = async () => {
    try {
      const response = await fetch(
        `${Endpoints.PRISM_GET_SCREEN_LIST_BY_ROLE_ID}?role_id=${roleId}`,
        {
          headers: {
            accept: "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      const result = await response.json();
      
      if (result.status === 200 && result.data) {
        // Group by screen_id
        const screenMap = {};
        result.data.forEach((item) => {
          if (!screenMap[item.screen_id]) {
            const screenInfo = allScreensData.find(s => s.screen_id === item.screen_id);
            
            screenMap[item.screen_id] = {
              screen_id: item.screen_id,
              screen_name: item.screen_name,
              sections: screenInfo?.sections || [],
            };
          }
        });

        const screens = Object.values(screenMap);
        
        // Set selectedScreens as array of IDs
        const screenIds = screens.map(s => s.screen_id);
        setSelectedScreens(screenIds);
        
        // Set screenOptions with formatted data
        const formattedOptions = screens.map(screen => ({
          id: screen.screen_id,
          label: screen.screen_name,
          fullData: screen,
        }));
        setScreenOptions(formattedOptions);

        // Set permissions from API data
        const permsObj = {};
        result.data.forEach((item) => {
          if (!permsObj[item.screen_id]) {
            permsObj[item.screen_id] = {
              create: item.create_perm === 1,
              read: item.read_perm === 1,
              delete: item.delete_perm === 1,
              print: item.print === 1,
              download: item.download === 1,
              sections: {},
            };
          }

          if (item.wb_scr_sec_id) {
            permsObj[item.screen_id].sections[item.wb_scr_sec_id] = {
              edit: item.update_perm === 1,
            };
          } else {
            permsObj[item.screen_id].edit = item.update_perm === 1;
          }
        });

        // Check if all sections are selected
        Object.keys(permsObj).forEach((screenId) => {
          const screen = screens.find((s) => s.screen_id === parseInt(screenId));
          if (screen && screen.sections.length > 0) {
            const allChecked = screen.sections.every(
              (sec) => permsObj[screenId].sections[sec.sec_id]?.edit
            );
            permsObj[screenId].allSections = allChecked;
          }
        });

        setPermissions(permsObj);
      }
    } catch (error) {
      console.error("Error fetching screens:", error);
    }
  };

  const fetchReportsByRoleId = async () => {
    try {
      const response = await fetch(
        `${Endpoints.PRISM_GET_REPORT_LIST_BY_ROLE_ID}?role_id=${roleId}`,
        {
          headers: {
            accept: "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      const result = await response.json();
      
      if (result.status === 200 && result.data) {
        const reports = result.data.map((item) => ({
          report_id: item.report_id,
          display_name: item.report_name,
          report_desc: item.report_desc,
        }));
        
        // Set selectedReports as array of IDs
        const reportIds = reports.map(r => r.report_id);
        setSelectedReports(reportIds);
        
        // Set reportOptions with formatted data
        const formattedOptions = reports.map(report => ({
          id: report.report_id,
          label: report.display_name,
          fullData: report,
        }));
        setReportOptions(formattedOptions);

        // Set report permissions
        const reportPermsObj = {};
        result.data.forEach((item) => {
          reportPermsObj[item.report_id] = {
            print: item.print === 1,
            download: item.download === 1,
          };
        });
        setReportPermissions(reportPermsObj);
      }
    } catch (error) {
      console.error("Error fetching reports:", error);
    }
  };

  // Fetch screens based on search key
  // const fetchScreens = async (searchKey) => {
  //   if (!searchKey || searchKey.trim().length < 2) {
  //     return;
  //   }

  //   try {
  //     const filtered = data.filter((item) =>
  //       item.screen_name.toLowerCase().includes(searchKey.toLowerCase())
  //     );

  //     const formattedOptions = filtered.map((screen) => ({
  //       id: screen.screen_id,
  //       label: screen.screen_name,
  //       fullData: screen,
  //     }));

  //     // Merge with existing options to avoid duplicates
  //     setScreenOptions(prevOptions => {
  //       const existingIds = new Set(prevOptions.map(opt => opt.id));
  //       const newOptions = formattedOptions.filter(opt => !existingIds.has(opt.id));
  //       return [...prevOptions, ...newOptions];
  //     });
  //   } catch (error) {
  //     console.error("Error fetching screens:", error);
  //   }
  // };

  // // Fetch reports based on search key
  // const fetchReports = async (searchKey) => {
  //   if (!searchKey || searchKey.trim().length < 2) {
  //     return;
  //   }

  //   try {
  //     const response = await fetch(
  //       `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-report-list-by-search-key?search_key=${searchKey}`,
  //       {
  //         method: "GET",
  //         headers: {
  //           accept: "application/json",
  //           Authorization: `Bearer ${accessToken}`,
  //         },
  //       }
  //     );
  //     const result = await response.json();
      
  //     if (result.status === 200 && result.data) {
  //       const formattedOptions = result.data.map((report) => ({
  //         id: report.report_id,
  //         label: report.display_name,
  //         fullData: report,
  //       }));
        
  //       // Merge with existing options to avoid duplicates
  //       setReportOptions(prevOptions => {
  //         const existingIds = new Set(prevOptions.map(opt => opt.id));
  //         const newOptions = formattedOptions.filter(opt => !existingIds.has(opt.id));
  //         return [...prevOptions, ...newOptions];
  //       });
  //     }
  //   } catch (error) {
  //     console.error("Error fetching reports:", error);
  //   }
  // };

  const fetchScreens = async (searchKey) => {
    if (!searchKey || searchKey.trim().length < 2) {
      return;
    }

    try {
      const filtered = data.filter((item) =>
        item.screen_name.toLowerCase().includes(searchKey.toLowerCase())
      );

      const formattedOptions = filtered.map((screen) => ({
        id: screen.screen_id,
        label: screen.screen_name,
        fullData: screen,
      }));

      // Put new search results FIRST, then existing options (selected screens will be last)
      setScreenOptions((prev = []) => {
        const map = new Map();
        // Add new search results first (unselected items)
        formattedOptions.forEach((n) => map.set(String(n.id), n));
        // Then add previous options that aren't duplicates (selected items)
        prev.forEach((p) => {
          if (!map.has(String(p.id))) map.set(String(p.id), p);
        });
        return Array.from(map.values());
      });
    } catch (error) {
      console.error("Error fetching screens:", error);
    }
  };

  const fetchReports = async (searchKey) => {
    if (!searchKey || searchKey.trim().length < 2) {
      return;
    }

    try {
      const response = await fetch(
        `${Endpoints.PRISM_GET_REPORT_LIST_BY_SEARCH_KEY}?search_key=${searchKey}`,
        {
          method: "GET",
          headers: {
            accept: "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      const result = await response.json();
      
      if (result.status === 200 && result.data) {
        const formattedOptions = result.data.map((report) => ({
          id: report.report_id,
          label: report.display_name,
          fullData: report,
        }));
        
        // Put new search results FIRST, then existing options (selected reports will be last)
        setReportOptions((prev = []) => {
          const map = new Map();
          // Add new search results first (unselected items)
          formattedOptions.forEach((n) => map.set(String(n.id), n));
          // Then add previous options that aren't duplicates (selected items)
          prev.forEach((p) => {
            if (!map.has(String(p.id))) map.set(String(p.id), p);
          });
          return Array.from(map.values());
        });
      }
    } catch (error) {
      console.error("Error fetching reports:", error);
    }
  };

  const toggleExpand = (screenId) => {
    setExpandedScreens((prev) => ({
      ...prev,
      [screenId]: !prev[screenId],
    }));
  };

  // Screen table headers
  const headers = [
    "Screen ID",
    "Screen Name",
    "Edit",
    "Create",
    "Read",
    "Delete",
    "Print & Download",
  ];

  // Build screen table data
  const tableData = (Array.isArray(selectedScreens) ? selectedScreens : [])
    .map((screenId) => {
      const opt = screenOptions.find((o) => o.id === screenId);
      if (!opt || !opt.fullData) return null;
      
      const screen = opt.fullData;
      const perms = permissions[screen.screen_id] || {};
      const isExpanded = expandedScreens[screen.screen_id];
      const sectionList = screen.sections || [];
      const hasSections = sectionList.length > 0;

      return [
        screenId, 
        screen.screen_name,

        // Edit Column with All Sections checkbox and expandable sections
        <div style={{ display: "flex", flexDirection: "column" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            {hasSections && (
              <>
                <input
                  type="checkbox"
                  className="cr-custom-checkbox"
                  checked={perms.allSections || false}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    handlePermissionChange(screen.screen_id, null, "allSections", checked);
                  }}
                  disabled={!isEditMode}
                />

                <span
                  onClick={() => toggleExpand(screen.screen_id)}
                  style={{
                    cursor: "pointer",
                    fontWeight: "bold",
                    marginLeft: "8px",
                    userSelect: "none",
                  }}
                >
                  {isExpanded ? "−" : "+"}
                </span>

                <span style={{ marginLeft: "8px", marginRight: "20px" }}>
                  All Sections
                </span>
              </>
            )}
            
            {!hasSections && (
              <input
                type="checkbox"
                className="cr-custom-checkbox"
                checked={perms.edit || false}
                onChange={(e) =>
                  handlePermissionChange(screen.screen_id, null, "edit", e.target.checked)
                }
                disabled={!isEditMode}
              />
            )}
          </div>

          {hasSections && isExpanded && (
            <div
              style={{
                marginTop: "10px",
                display: "flex",
                marginLeft: "24px",
                flexDirection: "column",
                gap: "10px",
              }}
            >
              {sectionList.map((section) => {
                const secPerm = perms.sections?.[section.sec_id]?.edit || false;
                return (
                  <label key={section.sec_id} style={{ display: "flex", gap: "6px" }}>
                    <input
                      type="checkbox"
                      className="cr-custom-checkbox"
                      checked={secPerm}
                      onChange={(e) => {
                        handlePermissionChange(
                          screen.screen_id,
                          section.sec_id,
                          "edit",
                          e.target.checked
                        );
                      }}
                      disabled={!isEditMode}
                    />
                    {section.sec_name}
                  </label>
                );
              })}
            </div>
          )}
        </div>,

        // Create
        <input
          type="checkbox"
          className="cr-custom-checkbox"
          checked={perms.create || false}
          onChange={(e) =>
            handlePermissionChange(screen.screen_id, null, "create", e.target.checked)
          }
          disabled={!isEditMode}
        />,

        // Read
        <input
          type="checkbox"
          className="cr-custom-checkbox"
          // checked={perms.read || false}
          checked={true}
          disabled={true} 
          onChange={(e) =>
            handlePermissionChange(screen.screen_id, null, "read", e.target.checked)
          }
          // disabled={!isEditMode}
        />,

        // Delete
        <input
          type="checkbox"
          className="cr-custom-checkbox"
          checked={perms.delete || false}
          onChange={(e) =>
            handlePermissionChange(screen.screen_id, null, "delete", e.target.checked)
          }
          disabled={!isEditMode}
        />,

        // Print
        <input
          type="checkbox"
          className="cr-custom-checkbox"
          checked={perms.print || false}
          onChange={(e) =>
            handlePermissionChange(screen.screen_id, null, "print", e.target.checked)
          }
          disabled={!isEditMode}
        />,

        // Download
        // <input
        //   type="checkbox"
        //   className="cr-custom-checkbox"
        //   checked={perms.download || false}
        //   onChange={(e) =>
        //     handlePermissionChange(screen.screen_id, null, "download", e.target.checked)
        //   }
        //   disabled={!isEditMode}
        // />,
      ];
    })
    .filter(Boolean);

  // Handle permission changes
  const handlePermissionChange = (screenId, secId, permissionType, checked) => {
    setPermissions((prev) => {
      const currentScreenPerms = prev[screenId] || {};
      const currentSections = currentScreenPerms.sections || {};
      const updatedSections = { ...currentSections };
      const screen = screenOptions.find(o => o.fullData?.screen_id === screenId)?.fullData;
      const sectionList = screen?.sections || [];

      // Handle "All Sections" checkbox
      if (permissionType === "allSections") {
        const newSections = {};
        sectionList.forEach(sec => {
          newSections[sec.sec_id] = {
            ...(updatedSections[sec.sec_id] || {}),
            edit: checked,
          };
        });

        return {
          ...prev,
          [screenId]: {
            ...currentScreenPerms,
            allSections: checked,
            edit: checked,
            sections: newSections,
          },
        };
      }

      // Handle individual section checkbox
      if (secId) {
        updatedSections[secId] = {
          ...(updatedSections[secId] || {}),
          edit: checked,
        };

        const allChecked = sectionList.every(sec => updatedSections[sec.sec_id]?.edit);
        const allUnchecked = sectionList.every(sec => !updatedSections[sec.sec_id]?.edit);
        const anyChecked = sectionList.some(sec => updatedSections[sec.sec_id]?.edit);

        return {
          ...prev,
          [screenId]: {
            ...currentScreenPerms,
            allSections: allChecked ? true : (allUnchecked ? false : currentScreenPerms.allSections),
            edit: anyChecked,
            sections: updatedSections,
          },
        };
      }

      // Handle other permissions
      const updatedScreenPerms = {
        ...currentScreenPerms,
        [permissionType]: checked,
        sections: updatedSections,
      };

      if (permissionType === "print" && checked) {
        updatedScreenPerms.download = true;
      }

      return {
        ...prev,
        [screenId]: updatedScreenPerms,
      };
    });
  };

  // Handle screen table row selection
  const handleScreenTableRowSelection = (newSelectedRows) => {
    isUpdatingFromScreenTable.current = true;
    setSelectedScreens(newSelectedRows);
    setTimeout(() => {
      isUpdatingFromScreenTable.current = false;
    }, 0);
  };

  // Handle delete screen
  const handleDeleteScreen = (screenId) => {
    setScreenOptions((prev) => prev.filter((o) => o.id !== screenId));
    setSelectedScreens((prev) => prev.filter((id) => id !== screenId));
    const updatedPermissions = { ...permissions };
    delete updatedPermissions[screenId];
    setPermissions(updatedPermissions);
  };

  // Report table headers
  const reportHeaders = ["Report ID", "Report Name", "Report Description", "Print & Download",];

  // Build report table data
  const reportTableData = (Array.isArray(selectedReports) ? selectedReports : [])
    .map((reportId) => {
      const opt = reportOptions.find((o) => o.id === reportId);
      if (!opt || !opt.fullData) return null;
      
      const report = opt.fullData;
      const perms = reportPermissions[report.report_id] || {};

      return [
        reportId,
        report.display_name,
        report.report_desc,
        
        // Print
        <input
          type="checkbox"
          className="cr-custom-checkbox"
          checked={perms.print || false}
          disabled={!isEditMode}
          onChange={(e) =>
            handleReportPermissionChange(report.report_id, "print", e.target.checked)
          }
        />,
        // Download
        // <input
        //   type="checkbox"
        //   className="cr-custom-checkbox"
        //   checked={perms.download || false}
        //   disabled={!isEditMode}
        //   onChange={(e) =>
        //     handleReportPermissionChange(report.report_id, "download", e.target.checked)
        //   }
        // />,
      ];
    })
    .filter(Boolean);

  // Handle report permission changes
  const handleReportPermissionChange = (reportId, type, checked) => {
    setReportPermissions((prev) => ({
      ...prev,
      [reportId]: {
        ...prev[reportId],
        [type]: checked,
      },
    }));
  };

  // Handle report table row selection
  const handleReportTableRowSelection = (newSelectedRows) => {
    isUpdatingFromReportTable.current = true;
    setSelectedReports(newSelectedRows);
    setTimeout(() => {
      isUpdatingFromReportTable.current = false;
    }, 0);
  };

  // Handle delete report
  const handleDeleteReport = (reportId) => {
    setReportOptions((prev) => prev.filter((o) => o.id !== reportId));
    setSelectedReports((prev) => prev.filter((id) => id !== reportId));
    const updated = { ...reportPermissions };
    delete updated[reportId];
    setReportPermissions(updated);
  };

  const handleUpdate = async (newStatus = status) => {
    if (!roleName || !roleCode || !description) {
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>Please fill all required fields!</span>
          </div>
        </div>
      );
      setActiveImg(InterogativeImg);
      return;
    }

    let errors = [];
    if (!roleName) {
      setRoleNameError(true);
      errors.push("Role Name");
    }

    if (!roleCode) {
      setRoleCodeError(true);
      errors.push("Role Code");
    }

    if (!description) {
      setDescriptionError(true);
      errors.push("Role Description");
    }

    if (roleNameError) errors.push("Role Name");
    if (roleCodeError) errors.push("Role Code");
    if (descriptionError) errors.push("Role Description");

    if (errors.length > 0) {
      const messageText =
        errors.length === 1
          ? `Please correct the highlighted field: ${errors[0]}!`
          : `Please correct the highlighted fields: ${errors.join(
            " and "
          )}!`;

      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <span>{messageText}</span>
          </div>
        </div>
      );
      setActiveImg(ErrorIcon);
      return;
    }

    if (selectedScreens.length === 0 && selectedReports.length === 0) {
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <span>Please select at least one Screen or one Report!</span>
          </div>
        </div>
      );
      setActiveImg(ErrorIcon);
      return;
    }

    const role_screen_list = selectedScreens.flatMap((screenId) => {
      const opt = screenOptions.find(o => o.id === screenId);
      if (!opt || !opt.fullData) return [];
      
      const screen = opt.fullData;
      const perms = permissions[screen.screen_id] || {};

      if (screen.sections?.length > 0) {
        return screen.sections.map((section) => ({
          role_id: parseInt(roleId),
          screen_id: screen.screen_id,
          wb_scr_sec_id: section.sec_id,
          client_id: clientId,
          create_perm: perms.create ? 1 : 0,
          read_perm: perms.read ? 1 : 0,
          // update_perm: perms.sections?.[section.sec_id]?.edit || perms.edit ? 1 : 0,
          update_perm: perms.sections?.[section.sec_id]?.edit ? 1 : 0,
          delete_perm: perms.delete ? 1 : 0,
          create_date: new Date().toISOString(),
          created_by: userName,
          last_modified_by: userName,
          last_modified_date: new Date().toISOString(),
          print: 1,
          // download: perms.download ? 1 : 0,
        }));
      }

      return {
        role_id: parseInt(roleId),
        screen_id: screen.screen_id,
        wb_scr_sec_id: null,
        client_id: clientId,
        create_perm: perms.create ? 1 : 0,
        read_perm: perms.read ? 1 : 0,
        update_perm: perms.edit ? 1 : 0,
        delete_perm: perms.delete ? 1 : 0,
        create_date: new Date().toISOString(),
        created_by: userName,
        last_modified_by: userName,
        last_modified_date: new Date().toISOString(),
        print: 1,
        // download: perms.download ? 1 : 0,
      };
    });

    const role_report_list = selectedReports.map((reportId) => {
      const opt = reportOptions.find(o => o.id === reportId);
      if (!opt || !opt.fullData) return null;
      
      const report = opt.fullData;
      const perms = reportPermissions[report.report_id] || {};
      
      return {
        role_id: parseInt(roleId),
        report_id: report.report_id,
        client_id: clientId,
        create_date: new Date().toISOString(),
        created_by: userName,
        last_modified_by: userName,
        last_modified_date: new Date().toISOString(),
        print: perms.print ? 1 : 0,
        // download: perms.download ? 1 : 0,
      };
    }).filter(Boolean);

    try {
      const url = `${Endpoints.PRISM_UPDATE_ROLE_DETAILS}?role_id=${roleId}&role_code=${roleCode}&role_name=${roleName}&role_desc=${description}&user_name=${userName}&status=${newStatus}`;

      const response = await fetch(url, {
        method: "PUT",
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          role_screen_list,
          role_report_list,
        }),
      });

      const result = await response.json();

      if (response.ok) {
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>{result.message || "Role updated successfully!"}</span>
            </div>
          </div>
        );
        setActiveImg(InterogativeImg);
        setIsEditMode(false);
        setTimeout(() => navigate("/create_role_dashboard"), 1000);
      } else {
        throw new Error(result.message || "Failed to update role");
      }
    } catch (error) {
      console.error("Error updating role:", error);
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>{`Error: ${error.message}`}</span>
          </div>
        </div>
      );
      setActiveImg(InterogativeImg);
    }
  };

  // const updateRoleStatus = (newStatus) => {
  //   setStatus(newStatus);   
  //   handleUpdate(newStatus); 
  // };

  const updateRoleStatus = (newStatus) => {
    const actionText = newStatus === 1 ? "activate" : "deactivate";
    setNoTimeSet(true);
    setMessageBox(
      <div className="Container-messageBOX">
        <div className="messagebox-insider1">
          <div className="loader-tc"></div>
          <span>Do you want to {actionText} this role?</span>
        </div>
        <div
          className="messagebox-insider2"
          style={{ display: "flex", gap: "10px", marginTop: "10px" }}
        >
          <button
            className="messagebox-cancel-btn-ok"
            onClick={async () => {
              setIsMessageBoxVisible(false);
              setStatus(newStatus);
              await handleUpdate(newStatus);
            }}
          >
            YES
          </button>
          <button
            className="messagebox-cancel-btn-ok"
            onClick={() => {
              setIsMessageBoxVisible(false);
            }}
          >
            NO
          </button>
        </div>
      </div>
    );
    setActiveImg(InterogativeImg);
    setIsMessageBoxVisible(true);
    setNoTimeSet(false);
  };


  const [roleNameError, setRoleNameError] = useState(false);
  const [roleCodeError, setRoleCodeError] = useState(false);
  const [descriptionError, setDescriptionError] = useState(false);

  const handleRoleNameChange = (e) => {
      let value = e.target.value;
      value = value.replace(/[^A-Za-z0-9-_ ]/g, "");
      setRoleName(value);
      const regex = /^[A-Za-z][A-Za-z0-9-_ ]*$/;
      if (value === "" || !regex.test(value)) {
        setRoleNameError(true);
      } else {
        setRoleNameError(false);
      }
    }; 

  const handleRoleCodeChange = (e) => {
    let value = e.target.value;
    value = value.replace(/[^A-Za-z0-9-]/g, "");
    if (value.length > 10) {
      value = value.slice(0, 10);
    }
    setRoleCode(value);
    if (value.trim() === "") {
      setRoleCodeError(true);
    } else {
      setRoleCodeError(false);
    }
  };

  const handleDescriptionChange = (e) => {
    const value = e.target.value;

    setDescription(value);
    if (value.trim() === "") {
      setDescriptionError(true);
    } else {
      setDescriptionError(false);
    }
  };


  return (
    <div className="create-role-container">
      <div className="create-role-container-ques-paper-del">
        <span className="create-role-heading">Manage Role</span>
        <div className="cr-header-btn-container">
          <button
            className="cr-cancel-btn"
            onClick={() => navigate("/create_role_dashboard")}
          >
            CANCEL
          </button>
          {status === 1 && (
            <button
              className="cr-cancel-btn"
              style={{ width: "140px" }}
              onClick={() => updateRoleStatus(0)}
            >
              DEACTIVATE
            </button>
          )}
          {status === 0 && (
            <button
              className="cr-create-btn"
              style={{ width: "140px" }}
              onClick={() => updateRoleStatus(1)}
            >
              ACTIVATE
            </button>
          )}
          {!isEditMode ? (
            <button className="cr-create-btn" onClick={() => setIsEditMode(true)}
             disabled={status === 0} 
              style={{
                opacity: status === 0 ? 0.5 : 1,
                cursor: status === 0 ? 'not-allowed' : 'pointer'
              }}
              >
              EDIT
            </button>
          ) : (
            <button className="cr-create-btn" onClick={() => handleUpdate(status)}>
              SAVE
            </button>
          )}
        </div>
      </div>

      {/* Details Section */}
      <div className="ques-paper-del">
        <div className="personal-header">
          <div className="header">
            <label>ROLE DETAILS</label>
          </div>
        </div>

        <div className="accordion-content">
          <div className="select-assign-test-container-ques-pap-del">
            <div className="grid-container-ques-paper-del">
              <div className="item1">
                <FormInputs
                  label="Role Name"
                  type="text"
                  required
                  value={roleName}
                  // onChange={(e) => setRoleName(e.target.value)}
                  onChange={handleRoleNameChange}
                  className={roleNameError ? "input-error" : ""}
                  disabled={!isEditMode}
                  maxlength="200"
                />
              </div>

              <div className="item2">
                <FormInputs
                  label="Role Code"
                  type="text"
                  required
                  value={roleCode}
                  // onChange={(e) => setRoleCode(e.target.value)}
                  onChange={handleRoleCodeChange}
                  disabled={!isEditMode}
                  className={roleCodeError ? "input-error" : ""}
                  maxlength="10"
                />
              </div>

              <div className="item3">
                <SelectedDropdownValues
                  label="Status"
                  options={[
                    { id: 1, label: "Active" },
                    { id: 0, label: "Inactive" },
                  ]}
                  selected={status}
                  setSelected={setStatus}
                  isRequired={true}
                  required
                  disabled={true}
                />
              </div>

              <div className="item4-creaete-role-description" style={{ gridColumn: "1 / -1"}}>
                <FormInputs
                  label="Description"
                  type="textarea"
                  value={description}
                  // onChange={(e) => setDescription(e.target.value)}
                  onChange={handleDescriptionChange}
                  className={descriptionError ? "input-error" : ""}
                  required
                  disabled={!isEditMode}
                  maxlength="200"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Add Screens Section */}
      <div className="ques-paper-del" style={{ marginTop: "20px" }}>
        <div className="personal-header">
          <div className="header">
            <label>ADD SCREENS</label>
          </div>
          <div
            className="accordion-btn"
            onClick={() => setIsOpenShareBranch((prev) => !prev)}
          >
            {isOpenShareBranch ? <div className="minus"></div> : <div className="plus">+</div>}
          </div>
        </div>

        {isOpenShareBranch && (
          <div className="accordion-content">
            <div
              className="select-assign-test-container-ques-pap-del"
              style={{ padding: "20px 0px 20px 0px" }}
            >
              <div className="grid-container-ques-paper-del">
                {isEditMode && (
                  <div className="item1" style={{marginLeft: "20px"}}>
                    <DropdownWithPagination
                      label="Search Screen"
                      width="100%"
                      selected={selectedScreens}
                      setSelected={setSelectedScreens}
                      onSearchInputChange={fetchScreens}
                      options={screenOptions}
                      isRequired={false}
                      showSelectAll={false}
                      allowMultiple={true}
                      itemsPerPage={4}
                      placeholder="Type Screen Name..."
                    />
                  </div>
                )}
                <div style={{ gridColumn: "1 / -1", marginTop: 16 }}>
                  <TableWithCrossSelections
                    headers={headers}
                    data={tableData}
                    searchPlaceholder="Search screens..."
                    selectedRows={selectedScreens}
                    setSelectedRows={handleScreenTableRowSelection}
                    renderQuestionText={(text) => text}
                    renderQuestionTextModel={(text) => text}
                    expandedStates={{}}
                    toggleImage={() => {}}
                    pageType="userEdit"
                    onRowLinkClick={(row) => console.log("Row clicked:", row)}
                    filterConfig={{}}
                    handleDeleteRow={isEditMode ? handleDeleteScreen : null}
                    hideIdColumn={true}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Add Reports Section */}
      <div className="ques-paper-del" style={{ marginTop: "20px" }}>
        <div className="personal-header">
          <div className="header">
            <label>ADD REPORTS NAME</label>
          </div>
          <div className="accordion-btn" onClick={() => setIsOpenReports((p) => !p)}>
            {isOpenReports ? <div className="minus"></div> : <div className="plus">+</div>}
          </div>
        </div>

        {isOpenReports && (
          <div className="accordion-content">
            <div
              className="select-assign-test-container-ques-pap-del"
              style={{ padding: "20px 0px 20px 0px" }}
            >
              <div className="grid-container-ques-paper-del">
                {isEditMode && (
                  <div className="item1" style={{marginLeft: "20px"}}>
                    <DropdownWithPagination
                      label="Search Report"
                      width="100%"
                      selected={selectedReports}
                      setSelected={setSelectedReports}
                      onSearchInputChange={fetchReports}
                      options={reportOptions}
                      isRequired={false}
                      showSelectAll={false}
                      allowMultiple={true}
                      itemsPerPage={4}
                      placeholder="Type Report Name..."
                    />
                  </div>
                )}
                <div style={{ gridColumn: "1 / -1", marginTop: 16 }}>
                  <TableWithCrossStudentGroup
                    headers={reportHeaders}
                    data={reportTableData}
                    searchPlaceholder="Search reports..."
                    selectedRows={selectedReports}
                    setSelectedRows={handleReportTableRowSelection}
                    renderQuestionText={(text) => text}
                    renderQuestionTextModel={(text) => text}
                    expandedStates={{}}
                    toggleImage={() => {}}
                    pageType="userEdit"
                    onRowLinkClick={(row) => console.log("Report clicked:", row)}
                    filterConfig={{}}
                    handleDeleteRow={isEditMode ? handleDeleteReport : null}
                    hideIdColumn={true}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default UpdatedCreateRole;